import type { ReactNode } from "react";
import type { TBreadcrumb } from "../../components/Breadcrumb";
import Footer from "../web/_components/footer";
import Navbar from "../web/_components/navbar";
import Hero from "./_components/Hero";
import UserSidebar from "./_components/Sidebar";

type Props = {
  children: ReactNode;
  title: string;
  breadcrumb: TBreadcrumb[];
  hideSidebar?: boolean;
};

export default function UserLayout({
  children,
  title,
  breadcrumb,
  hideSidebar,
}: Props) {
  return (
    <main>
      <Navbar />
      <Hero title={title} breadcrumb={breadcrumb} />
      {hideSidebar ? children : <UserSidebar>{children}</UserSidebar>}
      <Footer />
    </main>
  );
}

UserLayout.displayName = "UserLayout";
UserLayout.Sidebar = UserSidebar;
